import type { RefObject } from 'preact';
import { useEffect } from 'preact/hooks';

export const useEmojiPanelClose = (panelRef: RefObject<HTMLDivElement>, onClose: () => void) => {
  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target as Element;
      const isTrigger = target.closest('[data-emoji-panel-trigger]');

      if (panelRef.current && !panelRef.current.contains(target) && !isTrigger) {
        onClose();
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, panelRef]);
};
